import React from 'react';

const Navbar = ({ setActiveSection, activeSection }) => {
  const menuItems = [
    { id: 'inicio', label: 'Inicio' },
    { id: 'servicios', label: 'Servicios' },
    { id: 'telefonia', label: 'Telefonía' },
    { id: 'contacto', label: 'Contacto' }
  ];

  return (
    <nav className="navbar">
      <div className="nav-container">
        <div className="logo" onClick={() => setActiveSection('inicio')}>
          <img 
            src="/images/logo.png" 
            alt="Phone Paradise Logo" 
            style={{ height: '50px', width: 'auto', cursor: 'pointer' }}
          /> Phone Paradise
        </div>
        <ul className="nav-links">
          {menuItems.map(item => (
            <li
              key={item.id}
              onClick={() => setActiveSection(item.id)}
              className={activeSection === item.id ? 'active' : ''}
            >
              {item.label}
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;